import { t } from "i18next";
import { useProductContext } from "../ProductContext";
import { SummaryDataRow } from "./SummaryData";
import { IngredientCompletionService } from "../Ingredients/IngredientCompletionService";
import { Dimensions } from "src/context/EntityBasedScore/useDimensions";

export const useBuildSummaryData = (dimensionScore?: Dimensions[] | undefined) => {
    const { product, ssq, post, ingredientPosts, ingredientReferences } = useProductContext();
    const { totalIngredientCompletion } = IngredientCompletionService.calculateTotalCompletionRates(
        product?.productIngredients ?? [],
        ingredientPosts,
        ingredientReferences,
    );

    const ingredientsQuestionnairesWithCompletions = (product?.productIngredients ?? []).reduce((acc, pi) => {
        const posts = ingredientPosts?.filter((post) => post.ingredient.id === pi.ingredient.id) || [];

        const isCompletionDisplayable = IngredientCompletionService.isCompletionDisplayable(
            pi.ingredient,
            posts,
            ingredientReferences,
        );

        if (!isCompletionDisplayable) {
            return acc;
        }

        const ingredientSuppliers = pi.ingredient.ingredientSuppliers ?? [];

        return acc + ingredientSuppliers.length;
    }, 0);

    const totalCompletion = ssq && post ? post.completions.ssq.result : 0;

    const summaryData: SummaryDataRow[] = [
        {
            percentComplete: totalCompletion,
            count: dimensionScore?.length ?? 0,
            icon: "questionnaires",
            title: t("Products"),
            to: "../../questionnaire",
        },
        {
            percentComplete: totalIngredientCompletion,
            count: ingredientsQuestionnairesWithCompletions,
            icon: "ingredients",
            title: t("Ingredients"),
            to: "../ingredients",
        },
    ];

    return summaryData;
};
